export var FlowConversationBlockMode;
(function (FlowConversationBlockMode) {
    //@deprecated this is Create or Reopen
    FlowConversationBlockMode["WaitUntilClosed"] = "WaitUntilClosed";
    //@deprecated this is Reply or Close
    FlowConversationBlockMode["NonBlocking"] = "NonBlocking";
    FlowConversationBlockMode["Create"] = "Create";
    FlowConversationBlockMode["Reopen"] = "Reopen";
    FlowConversationBlockMode["Reply"] = "Reply";
    FlowConversationBlockMode["Close"] = "Close";
    FlowConversationBlockMode["Update"] = "Update";
})(FlowConversationBlockMode || (FlowConversationBlockMode = {}));
export var FlowConversationTagEditMode;
(function (FlowConversationTagEditMode) {
    FlowConversationTagEditMode["Edit"] = "Edit";
    FlowConversationTagEditMode["Replace"] = "Replace";
})(FlowConversationTagEditMode || (FlowConversationTagEditMode = {}));
//# sourceMappingURL=enums.js.map